module.exports = __webpack_public_path__ + "img/unmoving great library.2bf14033.png";